import request from '../utils/request';

const BASE_URL = '/banners';

// 轮播图 API
export const bannerApi = {
  // 分页查询轮播图列表
  // params: { page, pageSize, title, linkType, status }
  pageBanners: (params = {}) => {
    const { page = 1, pageSize = 10, title, linkType, status } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('pageSize', pageSize);
    if (title) queryParams.append('title', title);
    if (linkType) queryParams.append('linkType', linkType);
    if (status !== undefined && status !== null) queryParams.append('status', status);
    
    return request.get(`${BASE_URL}/list?${queryParams.toString()}`);
  },

  // 获取轮播图详情
  getBannerById: (id) => {
    return request.get(`${BASE_URL}/${id}`);
  },

  // 创建轮播图
  createBanner: (data) => {
    return request.post(BASE_URL, data);
  },

  // 更新轮播图
  updateBanner: (id, data) => {
    return request.put(`${BASE_URL}/${id}`, data);
  },

  // 删除轮播图
  deleteBanner: (id) => {
    return request.delete(`${BASE_URL}/${id}`);
  },

  // 获取启用的轮播图列表
  getEnabledBanners: () => {
    return request.get(`${BASE_URL}/enabled`);
  }
};

